import * as fromDatatype from '../datatype-library';

export interface bl_fi_mst_entity_driver_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    login_subject_guid:fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date:fromDatatype.TimestampTzDatatypeInterface;
    updated_date:fromDatatype.TimestampTzDatatypeInterface;
    namespace: fromDatatype.NamespaceDataFieldInterface;
    property_json:fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.RevisionDataFieldInterface;

}


export class bl_fi_mst_entity_driver_link_RowClass
  implements bl_fi_mst_entity_driver_link_RowInterface 
  {
    guid: fromDatatype.GuidDataFieldInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    login_subject_guid:fromDatatype.GuidDataFieldInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date:fromDatatype.TimestampTzDatatypeInterface;
    updated_date:fromDatatype.TimestampTzDatatypeInterface;
    namespace: fromDatatype.NamespaceDataFieldInterface;
    property_json:fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.RevisionDataFieldInterface;
  }